<template>
    <main>
        <form ref="candidato-form-liberar-teste" v-on:submit.prevent="executeEdit(model)" novalidate>

            <div class="row">
                <div class="form-group col-md-12">
                    <label for="teste.dtInicio">Deseja abrir a realização do teste?</label>
                </div>
                <div class="col-md-12">
                    <div class="alert alert-info">
                        Ao clicar em REALIZAR, você será deslogado do sistema e uma nova janela* será aberta para a realização do teste pelo candidato. <br />
                        <br />
                        <strong class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></strong><small><b> Verifique se está habilitado em seu browser <a href="https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DDesktop&hl=pt-BR" target="_blank">janelas em pop-up</a>.</b></small>
                    </div>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-md-12">
                    <br />
                    <button type="button" class="btn btn-warning" @click="executeEdit(model, true)">
                        <span>Enviar Link da Prova</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <br />
                    <button type="button" class="btn btn-default" @click="onBack()">
                        <span>Realizar teste depois</span>
                    </button>
                </div>

                <div class="col-md-6">
                    <br />
                    <button type="button" class="btn btn-success" @click="executeEdit(model)">
                        <span>Realizar teste agora</span>
                    </button>
                </div>
            </div>
        </form>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEnviarLinkProva" :hide-footer="true" title="Link de Acesso">
            <div>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" :placeholder="linkDeAcessoProva" aria-label="linkDeAcessoProva" aria-describedby="button-addon2" disabled>
                    <div class="input-group-append">
                        <button id="button-addon2" type="button" class="btn btn-outline-info" v-b-tooltip.hover.rigth title="Copiar Link de Acesso a Prova."
                                v-clipboard="linkDeAcessoProva"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler">
                            <i class="fa fa-clone"></i>
                        </button>
                    </div>
                    <!--<div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2">Button</button>
                    </div>-->
                </div>

                <!--<div class="row col-12">
                    <input type="text" disabled value="linkDeAcessoProva" />
                </div>-->
            </div>
            <div class="col-12 text-center">
                <button type="button" class="btn btn-info" @click="onEnviarLinkPorEmail()">
                    <i class="fa fa-envelope-o"></i>
                    <span> Enviar Link Por Email</span>
                </button>
            </div>

        </b-modal>
    </main>
</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import auth from '@/common/auth'
    import Vue from 'vue'
    import Clipboard from 'v-clipboard'
    import Global from '@/common/global'

    Vue.use(Clipboard)

    export default {
        name: "candidato-form-liberar-teste",
        mixins: [base],
        props: { id: Number, cpf: String, escolaid: Number, testeId: Number },
        data: () => ({

            model: {
                teste: {}
            },

            form: "candidato-form-liberar-teste",

            resources: {
                edit: 'candidato',
                filter: 'candidato',
                email: 'candidato/EnviarEmailLinkAcessoTeste',
            },

            dialogEnviarLinkProva: false,
            linkDeAcessoProva: '',

        }),

        methods: {

            executeEdit: function (model, linkProva) {
                if (this.formValidate() == false) return;

                model.attributeBehavior = "LiberarTeste";
                model.candidatoId = this.id;

                this.showLoading();

                new Api(this.resources.edit).put(model).then(data => {

                    this.defaultSuccessResult("Teste liberado com sucesso.");
                    this.testeId = data.data.testeId;

                    if (linkProva) {
                        this.dialogEnviarLinkProva = true;
                        this.gerarLinkDeAcessoProva(data.data);
                    }
                    else {
                        //this.$emit('on-saved', data.data)
                        this.onRealizarTeste(data.data);
                    }
                }, err => {
                    this.defaultErrorResult(err);
                })

            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

            clipboardSuccessHandler({ value, event }) {
                this.defaultSuccessResult("Link copiado com sucesso para a área de transferência.");
            },

            clipboardErrorHandler({ value, event }) {
                this.defaultErrorResult('O valor não pôde ser copiado.');
            },

            gerarLinkDeAcessoProva(model) {
                var token = auth.getAccessToken();
                var candidatoId = model.candidatoId;
                var testeId = model.testeId;
                var _url = '/teste-realizar/' + candidatoId + '/' + testeId;

                if (model.colaborador && model.colaborador.cpf)
                    _url += '/' + model.colaborador.cpf.replace(/\D+/g, '');
                else if (this.cpf)
                    _url += '/' + this.cpf.replace(/\D+/g, '');

                _url += '/?accesstoken=' + token;

                var routeData = this.$router.resolve({ path: _url });

                this.linkDeAcessoProva = Global.URL_CANDIDATO + routeData.href;                
            },

            onEnviarLinkPorEmail() {
                new Api(this.resources.email).post({ CandidatoId: this.id, EscolaId: this.escolaid, TesteId: this.testeId, LinkDeAcessoTeste: this.linkDeAcessoProva })
                    .then(data => {
                        this.defaultSuccessResult("Email enviado com sucesso.");
                    }, err => {
                        this.defaultErrorResult(err);
                    });
            },

            onRealizarTeste(model) {
                var token = auth.getAccessToken();
                var candidatoId = model.candidatoId;
                var testeId = model.testeId;

                var _url = '/teste-realizar/' + candidatoId + '/' + testeId;

                if (model.colaborador && model.colaborador.cpf)
                    _url += '/' + model.colaborador.cpf.replace(/\D+/g, '');
                else if (this.cpf)
                    _url += '/' + this.cpf.replace(/\D+/g, '');

                _url += '/?accesstoken=' + token;

                var routeData = this.$router.resolve({ path: _url });

                var params = [
                    'height=' + screen.availHeight,
                    'width=' + screen.availWidth,
                    'fullscreen=yes'
                ].join(',');

                var popup = window.open(routeData.href, "newWin", params);
                if (popup.outerWidth < screen.availWidth || popup.outerHeight < screen.availHeight) {
                    popup.resizeTo(screen.availWidth, screen.availHeight);
                    popup.moveTo(0, 0);
                }

                if (window.location.origin.indexOf("localhost") == -1)
                    auth.logout();
            }
        },

        mounted() {
            
        }
    };
</script>